// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f9e25d25","977":"4aa13563"}[chunkId] + ".chunk.js";
};